import { Controller } from "stimulus"
import { GitHub } from "../lib/github"
import Honeybadger from "../honeybadger"

// Downloads resolve against the R2 mirror first (latest.json is written by the
// release-published workflow in the beekeeper-studio repo), falling back to the
// GitHub API, then the GitHub releases page. Manifest fields (extension, arch,
// type) are precomputed to match GithubAsset's semantics in lib/github.js.
const DOWNLOADS_MANIFEST_URL = 'https://downloads.beekeeperstudio.io/latest.json'

export default class DownloadController extends Controller {

  static get targets() {
    return ['link', 'linkwrapper', 'yestarget', 'loading', 'nextSteps']
  }

  trackDownload() {
    if (window.fathom) {
      window.fathom.trackGoal('QXFWOA1N', 0)
    }
  }

  getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      });
    return vars;
  }

  initialize() {
    this.loading = true
    this.ext = this.getUrlVars()['ext']
    this.arch = this.getUrlVars()['arch'] || 'x86_64'
    this.type = this.getUrlVars()['type'] || 'installer'
    if (!this.ext) {
      // The page passes in its own /get, so a translated page stays in its
      // language.
      window.location = this.data.get('getUrl') || '/get'
      return
    } else {
      this.yestargetTarget.style.display = "block"
      this.loadingTarget.style.display = 'none'
    }

    const fake = this.ext === 'fake' && window.isDevelopment

    if (fake) {
      this.trackDownload()
      this.showLink("https://fake.com")
      console.log("FAKE DOWNLOAD")
    } else {
      this.resolveFromMirror().then((selected) => {
        this.trackDownload()
        this.go(selected.url)
      }).catch((error) => {
        Honeybadger.notify(error)
        this.resolveFromGithub()
      })
    }

    this.nextStepsTarget.style.display = ""
  }

  async resolveFromMirror() {
    const aborter = new AbortController()
    const timer = setTimeout(() => aborter.abort(), 7000)
    try {
      const response = await fetch(DOWNLOADS_MANIFEST_URL, { signal: aborter.signal })
      if (!response.ok) {
        throw new Error(`latest.json fetch failed: ${response.status}`)
      }
      const manifest = await response.json()
      const selected = (manifest.assets || []).find((a) => {
        return a.arch === this.arch &&
          a.extension === this.ext &&
          a.type === this.type
      })
      if (!selected) {
        throw new Error(`no asset in latest.json for ${this.ext}/${this.arch}/${this.type}`)
      }
      return selected
    } finally {
      clearTimeout(timer)
    }
  }

  // The pre-mirror flow, kept as the fallback tier when the mirror is
  // unreachable or has no matching asset.
  resolveFromGithub() {
    GitHub.getLatestRelease((response) => {

      const selected = response.assets.find((a) => {
        return a.arch === this.arch &&
          a.extension === this.ext &&
          a.type === this.type
      })

      if (!selected) {
        Honeybadger.notify('invalid download target')
        this.trackDownload()
        window.location = GitHub.releasePageFor()
        return
      }
      this.trackDownload()
      this.go(selected.url)

    }, (error) => {
      Honeybadger.notify(error)
      this.trackDownload()
      window.location = GitHub.releasePageFor()
    })
  }

  showLink(url) {
    this.linkTarget.href = url
    this.linkwrapperTarget.style.display = ""
  }

  go(url) {
    this.showLink(url)
    window.location = url
  }
}
